import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../css/SignupSuccess.css";

export default function SignupSuccess() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoToLogin = () => {
    navigate("/home");
  };

  return (
    <div className="page-container">
      <div className="success-card">
        <h1 className="success-title">{t("signupSuccess.title")}</h1>

        {/* Progress Indicator - All steps completed in gold */}
        <div className="success-progress-indicator">
          <div className="progress-step">
            <div className="progress-circle active">01</div>
          </div>
          <div className="progress-line active"></div>
          <div className="progress-step">
            <div className="progress-circle active">02</div>
          </div>
          <div className="progress-line active"></div>
          <div className="progress-step">
            <div className="progress-circle active">03</div>
          </div>
        </div>

        {/* Success Message */}
        <div className="success-message-container">
          <h2 className="success-message">{t("signupSuccess.message")}</h2>
          <p className="success-instruction">
            {t("signupSuccess.instruction")}
          </p>
        </div>

        {/* Checkmark Icon */}
        <div className="success-checkmark">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="38" stroke="#FFD100" strokeWidth="4" fill="none"/>
            <path
              d="M25 40 L35 50 L55 30"
              stroke="#FFD100"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="success-buttons-container">
          <button className="success-button login-button" onClick={handleGoToLogin}>
            {t("signupSuccess.goToLogin")}
          </button>
        </div>
      </div>
    </div>
  );
}
